export const SHOW_MAIN_TEXT = 'SHOW_MAIN_TEXT';
export const HIDE_MAIN_TEXT = 'HIDE_MAIN_TEXT';


export function show_main_text() {
  return {
    type: SHOW_MAIN_TEXT
  };
}
export function hide_main_text() {
  return {
    type: HIDE_MAIN_TEXT
  };
}



// WEBPACK FOOTER //
// ./src/actions/layout.js